require('bootstrap');

require('./header');
require('./emoji'); 
require('./login');
require('./shop-search-slider');
require('./inputMask');
